import React, { useState } from 'react';
import { RelatedItem as RelatedItemType } from '../../Related.types';

interface RelatedItemProps {
  item: RelatedItemType;
  onClick?: (item: RelatedItemType) => void;
  className: string;
}

export const RelatedItem = ({ item, onClick, className }: RelatedItemProps) => {
  const [bulletsVisible, setBulletsVisible] = useState(false);

  const toggleBullets = () => {
    setBulletsVisible(!bulletsVisible);
  };

  return (
    <>
      <div
        onClick={() => {
          onClick(item);
        }}
        className={`c-related-card ${className}`}
      >
        <a href={item.PageUrl}>
          <div className='c-related-card-container'>
            <div
              className='c-related-card-image'
              style={{
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: '50% 50%',
              }}
            >
              <img
                loading='lazy'
                src={item.ImageUrl}
                alt={item.ImageAlt}
                height='360'
                width='640'
              />
            </div>
            {item.USPList && bulletsVisible && (
              <div className='c-related-card-bullets-container'>
                {className === 'is-style-1' && <h4>{item.Title}</h4>}
                <div className='c-related-card-bullets-container-list'>
                  <ul>
                    {item.USPList.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
          </div>
          <div className='c-related-card-text'>
            <h4>{item.Title}</h4>
            {item.Summary && <p>{item.Summary}</p>}
          </div>
        </a>
        {className === 'is-style-1' && item?.USPList?.length > 0 && (
          <div className='c-related-card-more-btn' onClick={toggleBullets}>
            <i className='icon-ellipsis-v' />
          </div>
        )}
      </div>
    </>
  );
};
